import { ISelectOption } from 'ui-toolkit';
import StringMethods from './StringMethods';

const getOptionsListFromSnakeCase = (values: string[]): ISelectOption[] => {
  return values.map((item) => ({
    label: StringMethods.snakeCaseToCapitalize(item),
    value: item,
  }));
};

export default getOptionsListFromSnakeCase;
